var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"social-proof-product"},[_c('div',{staticClass:"social-proof-product__container"},[_c('hot-card-social-proof',_vm._b({attrs:{"type":"solid","theme":"light"}},'hot-card-social-proof',_vm.data,false))],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }